import { render, staticRenderFns } from "./LoginSlides.vue?vue&type=template&id=33d14f33&scoped=true&"
import script from "./LoginSlides.vue?vue&type=script&lang=js&"
export * from "./LoginSlides.vue?vue&type=script&lang=js&"
import style0 from "./LoginSlides.vue?vue&type=style&index=0&id=33d14f33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d14f33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VCol,VRow,VSheet})
